import { t } from '@aquabox/shared';

/** Sunucunun `rematch` sayıları (`POST/PATCH /api/regions`, `POST /api/regions/rematch`). */
export interface RematchCounts {
  checked: number;
  regionSet: number;
  assigned: number;
  unchanged: number;
  skipped: number;
}

/**
 * Yeniden eşleme sonucunu tek cümleye çevirir.
 *  - `null`      : sunucu yeniden eşlemeyi yapamadı (bölge kaydı yine de yazıldı) → uyarı cümlesi.
 *  - `undefined` : sunucudan rematch bilgisi gelmedi → boş.
 *  - sayılar     : hiçbir sipariş değişmediyse boş, değiştiyse sayılı cümle.
 */
export function rematchSentence(r: RematchCounts | null | undefined): string {
  if (r === null) return t('region.rematch.failed');
  if (r === undefined || r.regionSet + r.assigned === 0) return '';
  return t('region.rematch.result', { regionSet: r.regionSet, assigned: r.assigned });
}

/** Boş parçaları atıp cümleleri boşlukla birleştirir (ardışık toast birbirini ezmesin diye tek mesaj). */
export function joinSentences(...parts: string[]): string {
  return parts.filter((p) => p.length > 0).join(' ');
}
